import { request } from '@/util/vueRequest'

export function getMarkDownData() {
  return request({
    url: '/ad',
    method: 'GET',
  })
}
